function postCORS(url, data) {
	var form = document.createElement('form');
	form.setAttribute('method', 'post');
	form.setAttribute('action', url);
	form.setAttribute('display', 'none');

	for (var property in data) {
		if (data.hasOwnProperty(property)) {
			var input = document.createElement('input');
			input.setAttribute('type', 'hidden');
			input.setAttribute('name', property);
			input.setAttribute('value', data[property]);
			form.appendChild(input);
		}
	}

	document.body.appendChild(form);
	form.submit();
}

module.exports = postCORS;



/** WEBPACK FOOTER **
 ** ./frontend/components/excel-export/post-cors.js
 **/